import styled from '@emotion/styled';
import { PaymentStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import Text from 'components/text';
import { observer } from 'mobx-react';
import React from 'react';
import { computed } from 'mobx';
import Paginator from 'components/paginator';
import Spinner from 'components/spinner';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  margin-top: 40px;
`;

const PaymentHistoryTable = styled.table`
  width: 100%;
  th {
    text-align: left;
    background: #505050;
    color: white;
    font-size: 14px;
    padding: 5px;
  }
  td {
    font-size: 16px;
    padding: 5px;
    white-space: nowrap;
    width: calc(100% / 3) !important;
  }
`;

const Date = styled.div`
  font-size: 14px;
`;

const Amount = styled.div`
  font-weight: bold;
`;

const Product = styled.div`
  font-size: 14px;
`;

const RefundedIndicator = styled.span`
  color: red;
  font-size: 12px;
  margin-left: 8px;
`;

const TableContainer = styled.div`
  position: relative;
  opacity: ${props => props.isLoading ? 0.6 : 1};
`;

const SpinnerOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;

@observer
class SettingsBillingPaymentHistorySection extends React.Component {

  constructor(props) {
    super(props);
    PaymentStore.setLimit(5);
    PaymentStore.getIndex({ 
      queryStrings: { include_count: true, require_amount: true },
      filters: { 'payments.user_id': AppUI.user.id }
    });
  }

  @computed get payments() {
    return PaymentStore.indexData;
  }

  render() {

    if (!isPresent(this.payments) || this.payments.length === 0) {
      return null;
    }

    return (
      <Wrapper>
        <Text
          heading='4'
          margin='0 0 20px 0'
        >
          Payment History
        </Text>
        <TableContainer isLoading={PaymentStore.hasOutstandingRequests}>
          {PaymentStore.hasOutstandingRequests && (
            <SpinnerOverlay>
              <Spinner />
            </SpinnerOverlay>
          )}
          <PaymentHistoryTable>
            <thead>
              <tr>
                <th>Date</th>
                <th>Product</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {this.payments.map(payment => (
                <tr key={payment.id}>
                  <td>
                    <Date>
                      {payment.occurredAt?.formattedDateWithYear || payment.createdAt?.formattedDateWithYear || 'No date'}
                    </Date>
                  </td>
                  <td>
                    <Product>
                      {payment.membershipTitle || '-'}
                    </Product>
                  </td>
                  <td>
                    <Amount>
                      {payment.amountFormatted}
                      {payment.refunded && (
                        <RefundedIndicator>(Refunded)</RefundedIndicator>
                      )}
                    </Amount>
                  </td>
                </tr>
              ))}
            </tbody>
          </PaymentHistoryTable>
        </TableContainer>
        <Paginator
          store={PaymentStore}
          queryStrings={{ include_count: true, require_amount: true }}
          filters={{ 'payments.user_id': AppUI.user.id }}
          hideInput
        />
      </Wrapper>
    );

  }
};

export default SettingsBillingPaymentHistorySection;